import { MapPin, Phone, Package, Clock } from "lucide-react";
import { TYPE_STYLES, STATUS_STYLES, fmtTime } from "@/lib/schedule";

export const EventCard = ({ ev, compact = false, draggable = false, onOpen, showEngineer = false }) => {
  const t = TYPE_STYLES[ev.type] || TYPE_STYLES.Demo;
  const onDragStart = (e) => { e.dataTransfer.setData("text/plain", ev.id); e.dataTransfer.effectAllowed = "move"; };
  if (compact) {
    return (
      <button type="button" draggable={draggable} onDragStart={onDragStart} onClick={() => onOpen?.(ev)}
        className={`w-full text-left text-[11px] leading-tight rounded border border-l-4 ${t.bar} border-slate-200 bg-white px-1.5 py-1 hover:shadow-sm transition-shadow ${ev.status === "Cancelled" ? "opacity-60" : ""}`}
        data-testid={`event-pill-${ev.id}`}>
        <span className="font-semibold">{fmtTime(ev.start)}</span> {ev.company_name || ev.type}
        {showEngineer && <span className="block text-slate-500 truncate">{ev.engineer_name}</span>}
      </button>
    );
  }
  return (
    <button type="button" draggable={draggable} onDragStart={onDragStart} onClick={() => onOpen?.(ev)}
      className={`w-full text-left rounded-md border border-l-4 ${t.bar} border-slate-200 bg-white p-2.5 hover:shadow-md transition-shadow ${ev.status === "Cancelled" ? "opacity-60" : ""} ${draggable ? "cursor-grab active:cursor-grabbing" : ""}`}
      data-testid={`event-card-${ev.id}`}>
      <div className="flex items-center justify-between gap-2">
        <span className={`text-[10px] font-semibold uppercase tracking-wider border rounded px-1.5 py-0.5 ${t.chip}`} data-testid={`event-type-${ev.id}`}>{ev.type}</span>
        <span className={`text-[10px] font-semibold rounded px-1.5 py-0.5 ${STATUS_STYLES[ev.status] || ""}`} data-testid={`event-status-${ev.id}`}>{ev.status}</span>
      </div>
      <div className="mt-1.5 font-semibold text-sm text-slate-900 truncate">{ev.company_name || "—"}</div>
      <div className="mt-1 space-y-0.5 text-xs text-slate-600">
        <div className="flex items-center gap-1.5"><Clock className="w-3 h-3 shrink-0" />{fmtTime(ev.start)} – {fmtTime(ev.end)}</div>
        {ev.site_address && <div className="flex items-start gap-1.5"><MapPin className="w-3 h-3 shrink-0 mt-0.5" /><span className="line-clamp-2">{ev.site_address}</span></div>}
        {ev.contact_phone && <div className="flex items-center gap-1.5"><Phone className="w-3 h-3 shrink-0" />{ev.contact_phone}</div>}
        {ev.machine_model && <div className="flex items-center gap-1.5"><Package className="w-3 h-3 shrink-0" /><span className="truncate">{ev.machine_model}{ev.serial_number ? ` · ${ev.serial_number}` : ""}</span></div>}
        {showEngineer && ev.engineer_name && <div className="text-slate-500">Engineer: {ev.engineer_name}</div>}
      </div>
    </button>
  );
};
